import { render, staticRenderFns } from "./productCoop.vue?vue&type=template&id=0d5ad3bf&scoped=true"
import script from "./productCoop.vue?vue&type=script&lang=js"
export * from "./productCoop.vue?vue&type=script&lang=js"
import style0 from "./productCoop.vue?vue&type=style&index=0&id=0d5ad3bf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ad3bf",
  null
  
)

export default component.exports